import React, { useState, useEffect, useMemo, useRef } from 'react'
import { Col, Row, Input, Switch, Tooltip, Button, Table } from "antd";
import zoneIcon from '../../assets/images/icons/demand_icon.svg';
import HealthCenterIcon from '../../assets/newlayout/health_center_icon.svg';
import backButton from '../../assets/images/back_button_arrow.svg';
import SampleAnalyzedIcon from '../../assets/newlayout/icons/sample_analyzed_icon.svg';
import PlatformIcon from '../../assets/newlayout/icons/platform_icon.svg';
import FailedIcon from '../../assets/newlayout/icons/failed_icon.svg';
import PublisherIcon from '../../assets/newlayout/icons/publisher_icon.svg';
import ZoneIcon from '../../assets/newlayout/icons/zone_icon.svg';
import InventoryIcon from '../../assets/newlayout/icons/inventory_type_icon.svg';
import OuterRoundSVG from '../../assets/newlayout/icons/outer_round_svg.svg';
import InnerRoundSVG from '../../assets/newlayout/icons/inner_round_svg.svg';
import GreenBlurImg from '../../assets/newlayout/icons/green_blur.svg';
import RedBlurImg from '../../assets/newlayout/icons/red_blur.svg';
import OrangeBlurImg from '../../assets/newlayout/icons/orange_blur.svg';
import YellowBlurImg from '../../assets/newlayout/icons/yellow_blur.svg';
import { Link } from "react-router-dom";
import Accordion from 'react-bootstrap/Accordion';
import Chart from "react-apexcharts";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../config/config.json";
import FullLoader from "../../assets/images/full-page-loader.gif"

// --------------- Sample data (used as fallback when API is unavailable) ---------------
// const SAMPLE_REPORT_DATA = {
//     taskId: "TASK-000",
//     samplesAnalyzed: 5000,
//     failed: 364,
//     platform: "Adkernel",
//     publisher: "232730-Flickr",
//     inventoryType: "Website",
//     zones: ["Zone-001", "Zone-002", "Zone-003"],
//     overall: {
//         score: 51.7,
//         label: "Just Perfect!",
//     },
//     conditions: {
//         bidRequestValidity: {
//             severity: "Critical",
//             healthScore: 81.2,
//             items: [
//                 { conditionName: "UA Encoding Format", variableName: "device.ua / ua|user_agent", outputValue: "", healthPercent: 97.4 },
//                 { conditionName: "Secure Flag", variableName: "imp[].secure", outputValue: "", healthPercent: 97.4 },
//                 { conditionName: "Mutually Exclusive Site/App", variableName: "site|app", outputValue: "", healthPercent: 97.4 },
//                 { conditionName: "HTTPS Secure Impression Check", variableName: "imp[].secure", outputValue: "", healthPercent: 97.4 },
//             ],
//         },
//         auctionEligibility: {
//             severity: "Urgent",
//             healthScore: 75.8,
//             items: [
//                 { conditionName: "MIME Presence (RTB)", variableName: "imp[].video.mimes|imp[].banner.mimes", outputValue: "", healthPercent: 0 },
//                 { conditionName: "GDPR & Consent", variableName: "regs.gdpr|user.consent", outputValue: "", healthPercent: 97.4 },
//                 { conditionName: "COPPA Enforcement", variableName: "regs.coppa / coppa", outputValue: "", healthPercent: 97.4 },
//             ],
//         },
//         monetizationReadiness: {
//             severity: "High",
//             healthScore: 32.5,
//             items: [
//                 { conditionName: "User ID Availablity", variableName: "user.id|user.buyeruid", outputValue: "", healthPercent: 0 },
//                 { conditionName: "Creative Size Validity", variableName: "imp[].banner.w|imp[].banner.h", outputValue: "", healthPercent: 97.4 },
//             ],
//         },
//         optimizationSignals: {
//             severity: "Medium",
//             healthScore: 48.7,
//             items: [
//                 { conditionName: "Device Language Format", variableName: "device.language / device_language|lang", outputValue: "", healthPercent: 97.4 },
//                 { conditionName: "Non-Interstitial Request Detected", variableName: "imp[].instl", outputValue: "", healthPercent: 0 },
//             ],
//         },
//         optionalEnhancements: {
//             severity: "Alert",
//             healthScore: 0,
//             items: [
//                 { conditionName: "Blocked App List Detection", variableName: "bapp", outputValue: "", healthPercent: 0 },
//                 { conditionName: "Blocked Advertiser Detection", variableName: "badv", outputValue: "", healthPercent: 0 },
//             ],
//         },
//     },
// };

// --------------- Condition → Knowledge Article mapping ---------------
const CONDITION_ARTICLE_MAP = {
    "Ad Duration Numeric|CTV": "Ad Duration Numeric",
    "Ad Duration Numeric|InApp": "Ad Duration Numeric",
    "Ad Duration Numeric|Website": "Ad Duration Numeric",
    "App Bundle|CTV": "App Bundle",
    "App Category Validity|CTV": "App Category Validity",
    "App Category Validity|InApp": "App Category Validity",
    "App Domain|CTV": "App Domain",
    "App Domain|InApp": "App Domain",
    "App Name|CTV": "App Name",
    "App Store URL|CTV": "App Store URL",
    "App Store URL|InApp": "App Store URL",
    "Auction Type Check|CTV": "Auction Type Check",
    "Auction Type Check|InApp": "Auction Type Check",
    "Auction Type Check|Website": "Auction Type Check",
    "Audience Rating|CTV": "Audience Rating",
    "Blocked Advertiser Detection|InApp": "Blocked Advertiser Detection",
    "Blocked Advertiser Detection|Website": "Blocked Advertiser Detection",
    "Blocked App List Detection|InApp": "Blocked App List Detection",
    "Blocked App List Detection|Website": "Blocked App List Detection",
    "Blocked Category Detection|InApp": "Blocked Category Detection",
    "Blocked Category Detection|Website": "Blocked Category Detection",
    "Blocked Creative Attribute Detection|InApp": "Blocked Creative Attribute Detection",
    "Blocked Creative Attribute Detection|Website": "Blocked Creative Attribute Detection",
    "BuyerUID Populated|Website": "BuyerUID Populated",
    "Channel Name Validity|CTV": "Channel Name Validity",
    "Content Category Validity|CTV": "Content Category Validity",
    "Content Context Code|CTV": "Content Context Code",
    "Content Genre|CTV": "Content Genre",
    "Content Language Format|CTV": "Content Language Format",
    "Content Network|CTV": "App Name",
    "Content Title|CTV": "Content Title",
    "COPPA Enforcement|CTV": "COPPA Enforcement",
    "COPPA Enforcement|InApp": "COPPA Enforcement",
    "COPPA Enforcement|Website": "COPPA Enforcement",
    "Creative Size Validity|InApp": "Creative Size Validity",
    "Creative Size Validity|Website": "Creative Size Validity",
    "CTV User Agent Validity|CTV": "CTV User Agent Validity",
    "Device Language Format|CTV": "Device Language Format",
    "Device Language Format|InApp": "Device Language Format",
    "Device Language Format|Website": "Device Language Format",
    "Device Type Alignment|CTV": "Device Type Alignment",
    "Device Type Alignment|InApp": "Device Type Alignment",
    "Device Type Alignment|Website": "Device Type Alignment",
    "GDPR & Consent|CTV": "GDPR & Consent",
    "GDPR & Consent|InApp": "GDPR & Consent",
    "GDPR & Consent|Website": "GDPR & Consent",
    "HTTPS Secure Impression Check|InApp": "HTTPS Secure Impression Check",
    "HTTPS Secure Impression Check|Website": "HTTPS Secure Impression Check",
    "IFA Missing With Privacy Flag|CTV": "IFA Missing With Privacy Flag",
    "IFA Presence|CTV": "IFA Presence",
    "IFA Presence|InApp": "IFA Presence",
    "IFA Type Validity|InApp": "IFA Type Validity",
    "Invalid Device Screen Size|InApp": "Invalid Device Screen Size",
    "Invalid Device Screen Size|Website": "Invalid Device Screen Size",
    "Invalid IP Address Format|InApp": "Invalid IP Address Format",
    "Invalid IP Address Format|Website": "Invalid IP Address Format",
    "Inventory Partner Domain Parameter|CTV": "Inventory Partner Domain Parameter",
    "Livestream Flag|CTV": "Livestream Flag",
    "Low Auction Timeout|CTV": "Low Auction Timeout",
    "Low Auction Timeout|InApp": "Low Auction Timeout",
    "Low Auction Timeout|Website": "Low Auction Timeout",
    "Max Duration Threshold|CTV": "Max Duration Threshold",
    "Max Duration Threshold|InApp": "Max Duration Threshold",
    "Max Duration Threshold|Website": "Max Duration Threshold",
    "MIME Presence (RTB)|CTV": "MIME Presence (RTB)",
    "MIME Presence (RTB)|InApp": "MIME Presence (RTB)",
    "MIME Presence (RTB)|Website": "MIME Presence (RTB)",
    "Mutually Exclusive Site/App|InApp": "Mutually Exclusive Site/App",
    "Mutually Exclusive Site/App|Website": "Mutually Exclusive Site/App",
    "Native Asset ID Uniqueness|InApp": "Native Asset ID Uniqueness",
    "Native Asset ID Uniqueness|Website": "Native Asset ID Uniqueness",
    "Native Assets Array Validity|InApp": "Native Assets Array Validity",
    "Native Assets Array Validity|Website": "Native Assets Array Validity",
    "Native Data Length Validity|InApp": "Native Data Length Validity",
    "Native Data Length Validity|Website": "Native Data Length Validity",
    "Native Data Type Validity|InApp": "Native Data Type Validity",
    "Native Data Type Validity|Website": "Native Data Type Validity",
    "Native Event Tracker Validity|InApp": "Native Event Tracker Validity",
    "Native Event Tracker Validity|Website": "Native Event Tracker Validity",
    "Native Image Type Validity|InApp": "Native Image Type Validity",
    "Native Image Type Validity|Website": "Native Image Type Validity",
    "Native Request Field Presence|InApp": "Native Request Field Presence",
    "Native Request Field Presence|Website": "Native Request Field Presence",
    "Native Title Length Validity|InApp": "Native Title Length Validity",
    "Native Title Length Validity|Website": "Native Title Length Validity",
    "Native Video Dimension Validity|Website": "Native Video Dimension Validity",
    "Native Video Duration Validity|InApp": "Native Video Dimension Validity",
    "Native Video Duration Validity|Website": "Native Video Dimension Validity",
    "Native Video MIME Validity|InApp": "Native Video MIME Validity",
    "Native Video MIME Validity|Website": "Native Video MIME Validity",
    "Non-Interstitial Request Detected|InApp": "Non-Interstitial Request Detected",
    "Non-Interstitial Request Detected|Website": "Non-Interstitial Request Detected",
    "OpenRTB Version Eligibility|CTV": "OpenRTB Version Eligibility",
    "Player Dimensions (CTV)|CTV": "Player Dimensions (CTV)",
    "Privacy Flags (LMT/DNT)|CTV": "Privacy Flags (LMT/DNT)",
    "Privacy Flags (LMT/DNT)|InApp": "Privacy Flags (LMT/DNT)",
    "Privacy Flags (LMT/DNT)|Website": "Privacy Flags (LMT/DNT)",
    "Production Quality Code|CTV": "Production Quality Code",
    "Rewarded Inventory Signal Present|InApp": "Rewarded Inventory Signal Present",
    "Schain Absence|CTV": "Schain Absence",
    "Secure Flag|Website": "Secure Flag",
    "SSAI Enabled Flag|CTV": "SSAI Enabled Flag",
    "SSAI Vendor|CTV": "SSAI Vendor",
    "Start Delay Values|CTV": "Start Delay Values",
    "UA Encoding Format|CTV": "UA Encoding Format",
    "UA Encoding Format|InApp": "UA Encoding Format",
    "UA Encoding Format|Website": "UA Encoding Format",
    "User ID Availablity|Website": "User ID Availablity",
};

const normalizeInventoryType = (type) => {
    const t = (type || "").toLowerCase();
    if (t === "ctv") return "CTV";
    if (t === "website") return "Website";
    if (t === "inapp") return "InApp";
    return type || "";
};

// --------------- Helpers ---------------
const getSeverityInfo = (severity) => {
    const map = {
        urgent: { badgeClassName: "--urgent", badgeLabel: "Urgent" },
        critical: { badgeClassName: "--critical", badgeLabel: "Critical" },
        high: { badgeClassName: "--high", badgeLabel: "High" },
        medium: { badgeClassName: "--medium", badgeLabel: "Medium" },
        alert: { badgeClassName: "--alert", badgeLabel: "Alert" },
        warning: { badgeClassName: "--warning", badgeLabel: "Warning" },
    };
    const key = (severity || "").toLowerCase();
    return map[key] || { badgeClassName: "--warning", badgeLabel: severity || "-" };
};

const getHealthClass = (health) => {
    const h = typeof health === "number" ? health : 0;
    if (h >= 91) return "--green";
    if (h >= 61) return "--yellow";
    if (h >= 41) return "--orange";
    return "--red";
};

const safeStr = (val) =>
    val !== null && val !== undefined && val !== "" ? String(val) : "-";

// Convert camelCase key → "Title Case" label (e.g. "bidRequestValidity" → "Bid Request Validity")
const camelToTitle = (str) =>
    (str || "").replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());

const CONDITION_LABEL_MAP = {
    bidRequestValidity: "Bid Request Validity",
    auctionEligibility: "Auction Eligibility",
    monetizationReadiness: "Monetization Readiness",
    optimizationSignals: "Optimization Signals",
    optionalEnhancements: "Optional Enhancements",
};

// --------------- Component ---------------
const ViewReportV2 = ({ handlePageViewChange, rowData }) => {
    const [reportData, setReportData] = useState(null);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const [showOnlyFailed, setShowOnlyFailed] = useState(false);
    const [apiMessage, setApiMessage] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [pdfExporting, setPdfExporting] = useState(false);
    const pdfRef = useRef(null);
    const pdfSnapshotRef = useRef(null);

    // After initial data load (no filters applied), freeze a DOM clone for PDF export.
    // This avoids having to clear search/filter state during export.
    useEffect(() => {
        if (loading || !pdfRef.current) return;
        const timer = setTimeout(() => {
            if (pdfRef.current) {
                pdfSnapshotRef.current = pdfRef.current.cloneNode(true);
            }
        }, 800); // wait for ApexCharts to finish painting
        return () => clearTimeout(timer);
    }, [loading]);

    const handlePdfExport = async () => {
        if (pdfExporting) return;
        setPdfExporting(true);

        let offscreenHost = null;

        try {
            const [{ default: html2canvas }, { jsPDF }] = await Promise.all([
                import('html2canvas'),
                import('jspdf'),
            ]);

            const liveEl = pdfRef.current;
            if (!liveEl) return;

            // Mount the frozen snapshot off-screen so html2canvas can read computed styles.
            // Falls back to live element if snapshot isn't ready yet.
            offscreenHost = document.createElement('div');
            offscreenHost.style.cssText = `position:fixed;top:0;left:-${liveEl.offsetWidth + 200}px;width:${liveEl.offsetWidth}px;z-index:-1;`;
            offscreenHost.appendChild((pdfSnapshotRef.current || liveEl).cloneNode(true));
            document.body.appendChild(offscreenHost);

            const element = offscreenHost.firstElementChild;

            const reportTitle = taskName !== '-' ? taskName : taskId;
            const generatedDate = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

            // Ensure all web fonts (Poppins etc.) are fully loaded before capture
            await document.fonts.ready;

            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                allowTaint: true,
                logging: false,
                windowWidth: liveEl.offsetWidth,
                windowHeight: element.scrollHeight,
                // onclone runs on a hidden clone — the live DOM is never touched, so no flash
                onclone: (clonedDoc, clonedEl) => {
                    // Hide search/toggle section
                    const search = clonedEl.querySelector('.search_with_toggle_design');
                    if (search) search.style.display = 'none';

                    // Suppress accordion chevrons; widen content area to reduce side padding
                    const chevronStyle = clonedDoc.createElement('style');
                    chevronStyle.textContent = `
                        .accordion-button::after { display: none !important; }
                        .container_box--collaspe_form { width: 90% !important; }
                        .apexcharts-text,
                        .apexcharts-datalabel-value,
                        .apexcharts-datalabel-label { font-family: 'Poppins', sans-serif !important; }
                    `;
                    clonedDoc.head.appendChild(chevronStyle);

                    // Remove "No. of Zone(s)" stat from PDF only
                    clonedEl.querySelectorAll('.img_width_text').forEach(el => {
                        if (el.textContent.includes('No. of Zone')) {
                            const col = el.closest('.ant-col');
                            if (col) col.style.display = 'none';
                        }
                    });

                    // Shift the ApexCharts value + label text upward so they aren't clipped at bottom
                    clonedEl.querySelectorAll('.apexcharts-datalabel-value, .apexcharts-datalabel-label').forEach(el => {
                        const currentY = parseFloat(el.getAttribute('y') || '0');
                        el.setAttribute('y', String(currentY - 12));
                    });

                    // Build header banner and prepend to the clone
                    const wrapper = clonedDoc.createElement('div');
                    wrapper.style.cssText = 'margin-bottom: 16px; width: 100%; box-sizing: border-box;';

                    const card = clonedDoc.createElement('div');
                    card.style.cssText = [
                        'background-color:#07273B',
                        'border-radius: 16px',
                        'padding: 22px 28px',
                        'font-family: Poppins, sans-serif',
                        'width: 100%',
                        'box-sizing: border-box',
                    ].join(';');

                    // Logo row (icon + "Helix" text)
                    const logoRow = clonedDoc.createElement('div');
                    logoRow.style.cssText = 'display:flex; align-items:center; gap:10px; margin-bottom:20px;';
                    logoRow.innerHTML = `
                        <svg width="32" height="32" viewBox="0 0 45.5236 45.5236" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <defs>
                            <clipPath id="pdf_hdr_c"><rect width="45.5236" height="45.5236" fill="white"/></clipPath>
                            <radialGradient id="pdf_hdr_g0" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(13.0299 22.769) rotate(113.091) scale(20.5274 8.63299)">
                              <stop stop-color="#7174DF"/><stop offset="0.185" stop-color="#7170DE"/><stop offset="1" stop-color="#2DD1DA"/>
                            </radialGradient>
                            <radialGradient id="pdf_hdr_g1" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(13.5422 22.1108) rotate(-27.8241) scale(5.95851 8.52149)">
                              <stop stop-color="#7172DE"/><stop offset="0.385" stop-color="#736FDE"/><stop offset="1" stop-color="#8952E0"/>
                            </radialGradient>
                          </defs>
                          <g clip-path="url(#pdf_hdr_c)">
                            <path d="M15.5965 45.5525H6.40364C4.20123 45.5525 2.71341 43.3044 3.57421 41.2771L11.0913 23.5741C11.2734 23.0617 11.2574 22.769 11.2574 22.769H15.372C15.367 23.1192 15.3072 23.3541 15.1524 23.7244L7.86005 40.959C7.6967 41.3451 7.98009 41.7727 8.39927 41.7727H13.9495C15.0653 41.7727 16.0731 41.1058 16.5093 40.0788L27.4208 14.389C29.1843 10.237 35.0651 10.2259 36.8443 14.3712L37.6214 16.182L35.499 20.9392L34.0038 17.445C33.2934 15.7848 30.9385 15.7883 30.2332 17.4507L19.3695 43.0548C18.727 44.5691 17.2414 45.5525 15.5965 45.5525Z" fill="url(#pdf_hdr_g0)"/>
                            <path d="M15.5965 0.000640869H6.40364C4.20123 0.000640869 2.71341 2.24879 3.57421 4.27602L11.0913 21.9791C11.2734 22.4914 11.2574 22.7842 11.2574 22.7842H15.372C15.367 22.434 15.3072 22.1991 15.1524 21.8288L7.86005 4.59411C7.6967 4.20806 7.98009 3.78044 8.39927 3.78044H13.9495C15.0653 3.78044 16.0731 4.44733 16.5093 5.47436L22.9848 20.7201L25.0514 15.8897L19.3695 2.49836C18.727 0.984083 17.2414 0.000640869 15.5965 0.000640869Z" fill="url(#pdf_hdr_g1)"/>
                            <path d="M27.0811 29.2022L28.8814 24.9057L30.2574 28.1114C30.96 29.7508 33.2874 29.7654 34.0193 28.126L40.8991 12.5221C41.0455 12.2 41.47 12.1708 41.6603 12.4489L43.6071 15.3618C43.6949 15.4789 43.7096 15.6399 43.651 15.7863L37.1225 30.7901C35.2928 34.9911 29.2913 34.8594 27.6519 30.5851L27.0811 29.2022Z" fill="#8952E0"/>
                            <path d="M41.4691 25.0664L39.3906 29.8969L41.1326 34.2445C41.279 34.5958 41.762 34.6104 41.9377 34.2591L43.6942 30.6289C43.7528 30.5118 43.7528 30.3801 43.6942 30.263L41.4691 25.0664Z" fill="#2DD1DA"/>
                          </g>
                        </svg>`;
                    const helixLabel = clonedDoc.createElement('span');
                    helixLabel.textContent = 'Helix';
                    helixLabel.style.cssText = 'color:#FFFFFF; font-weight:600; font-size:18px; letter-spacing:0.3px;';
                    logoRow.appendChild(helixLabel);

                    // Title
                    const title = clonedDoc.createElement('h2');
                    title.style.cssText = 'color:#FFFFFF; font-weight:700; font-size:26px; margin:0 0 10px; line-height:1.3;';
                    title.appendChild(clonedDoc.createTextNode('Health Report '));
                    const titleSub = clonedDoc.createElement('span');
                    titleSub.style.cssText = 'font-weight:400; color:#CBD5E1;';
                    titleSub.textContent = `– ${reportTitle}`;
                    title.appendChild(titleSub);

                    // Date
                    const dateEl = clonedDoc.createElement('p');
                    dateEl.style.cssText = 'color:#FFFFFF; font-size:13px; margin:0; font-weight:400;';
                    dateEl.textContent = `Generated on ${generatedDate}`;

                    card.appendChild(logoRow);
                    card.appendChild(title);
                    card.appendChild(dateEl);
                    wrapper.appendChild(card);

                    // Insert inside container_box--collaspe_form so the header
                    // shares the same container width as the health card and accordions
                    const formContainer = clonedEl.querySelector('.container_box--collaspe_form') || clonedEl;
                    formContainer.insertBefore(wrapper, formContainer.firstChild);
                },
            });

            const SCALE = 3;
            const pdfWidth = canvas.width / SCALE;
            const pdfHeight = canvas.height / SCALE;

            const pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'px',
                format: [pdfWidth, pdfHeight],
            });

            pdf.addImage(canvas.toDataURL('image/jpeg', 1), 'JPEG', 0, 0, pdfWidth, pdfHeight);
            pdf.save(`${taskId}_health_report.pdf`);

        } catch (err) {
            console.error('PDF export failed:', err);
        } finally {
            if (offscreenHost?.parentNode) offscreenHost.parentNode.removeChild(offscreenHost);
            setPdfExporting(false);
        }
    };

    const handleDownload = () => {
        const token = Cookies.get("token_xapads_ssp");
        const tId = rowData?.taskId;
        if (!token || !tId || downloading) return;
        setDownloading(true);
        axios
            .get(configData.SERVER_URL + `healthCenter/download?taskId=${tId}`, {
                headers: { "x-access-token": token },
                responseType: "blob",
            })
            .then((res) => {
                const blob = new Blob([res.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                const url = window.URL.createObjectURL(blob);
                const anchor = document.createElement("a");
                anchor.href = url;
                anchor.download = `${tId}.xlsx`;
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
                window.URL.revokeObjectURL(url);
                setDownloading(false);
            })
            .catch(() => { setDownloading(false); });
    };

    useEffect(() => {
        const token = Cookies.get("token_xapads_ssp");
        const taskId = rowData?.taskId;
        if (!token || !taskId) {
            setReportData(null);
            setLoading(false);
            return;
        }
        axios
            .get(configData.SERVER_URL + `healthCenter/view?taskId=${taskId}`, {
                headers: { "x-access-token": token },
            })
            .then((res) => {
                if (res.data?.success === false) {
                    setReportData(null);
                    setApiMessage(res.data?.message || "Something went wrong. Please try again.");
                } else {
                    const dataArr = res.data?.data;
                    const apiData = Array.isArray(dataArr) ? dataArr[0] : dataArr;
                    setReportData(apiData && typeof apiData === "object" ? apiData : null);
                    setApiMessage(null);
                }
                setLoading(false);
            })
            .catch((err) => {
                setReportData(null);
                setApiMessage(err?.response?.data?.message || "Failed to load report. Please try again.");
                setLoading(false);
            });
    }, [rowData?.taskId]);

    // --------------- Derived from API/sample data (new JSON structure) ---------------
    const overallHealth = typeof reportData?.overall?.score === "number"
        ? reportData.overall.score : 0;
    const healthLabelFromAPI = reportData?.overall?.label;

    const sampleAnalyzed = reportData?.samplesAnalyzed != null && reportData.samplesAnalyzed !== ""
        ? reportData.samplesAnalyzed : "-";
    const failed = reportData?.failed != null && reportData.failed !== ""
        ? reportData.failed : "-";

    // profiles: derived from conditions healthScore values for radial chart
    const profiles = useMemo(() => {
        const conditionsObj = reportData?.conditions;
        if (!conditionsObj || typeof conditionsObj !== "object") return [];
        return Object.entries(conditionsObj)
            .filter(([, val]) => val && typeof val.healthScore === "number")
            .map(([key, val]) => ({
                value: val.healthScore,
                label: CONDITION_LABEL_MAP[key] || camelToTitle(key),
            }));
    }, [reportData]);

    // --------------- Derived from rowData (table record) ---------------
    const taskId = safeStr(rowData?.taskId);
    const taskName = safeStr(rowData?.taskName);
    const platform = safeStr(rowData?.platform || reportData?.platform);
    const publisherId = safeStr(rowData?.publisherId || reportData?.publisher);
    const rawInventoryType = rowData?.inventoryType || reportData?.inventoryType;
    const inventoryTypeDisplay =
        !rawInventoryType ? "-"
            : String(rawInventoryType).toLowerCase() === "ctv" ? "CTV"
                : String(rawInventoryType).toLowerCase() === "website" ? "Website"
                    : String(rawInventoryType).toLowerCase() === "inapp" ? "Inapp"
                        : String(rawInventoryType);
    // zones: prefer API array, fall back to rowData zones array
    const apiZones = Array.isArray(reportData?.zones) ? reportData.zones : [];
    const rowZones = Array.isArray(rowData?.zones) ? rowData.zones : [];
    const allZones = apiZones.length > 0 ? apiZones : rowZones;
    const zoneCount = allZones.length > 0 ? allZones.length : "-";

    // --------------- RadialChart (SVG arc) ---------------
    const RadialChart = ({ data }) => {
        if (!data || data.length === 0) return null;

        const width = 800;
        const height = 355;
        const centerX = width / 2;
        const centerY = 355;
        const radius = 250;
        const total = data.length;
        const dotRadius = 6;
        const dotRingRadius = 9;
        const dotRingStrokeWidth = 2;
        const pointPositionAdjustments = {
            0: { dotDx: 0, dotDy: 0, valueDx: 0, valueDy: -15, labelDx: -5, labelDy: -15 },
            1: { dotDx: 0, dotDy: 0, valueDx: 0, valueDy: 0, labelDx: -5, labelDy: 0 },
            2: { dotDx: 0, dotDy: 2, valueDx: 0, valueDy: -12, labelDx: 0, labelDy: -15 },
            3: { dotDx: 0, dotDy: 0, valueDx: 0, valueDy: 0, labelDx: 5, labelDy: 0 },
            4: { dotDx: 0, dotDy: 0, valueDx: 2, valueDy: -15, labelDx: 5, labelDy: -15 },
        };

        const getCoordinates = (index) => {
            const startAngle = -90;
            const endAngle = 90;
            const angleDeg =
                total === 1
                    ? 0
                    : startAngle + (index / (total - 1)) * (endAngle - startAngle);
            const angleRad = (angleDeg * Math.PI) / 180;
            return {
                x: centerX + radius * Math.sin(angleRad),
                y: centerY - radius * Math.cos(angleRad),
                angle: angleDeg,
            };
        };

        const getColor = (value) => {
            if (value >= 91) return "#16a34a";
            if (value >= 61) return "#BFB200";
            if (value >= 41) return "#f59e0b";
            return "#dc2626";
        };

        const getYOffset = (angle) => -40 - Math.abs(angle) * 0.05;
        const getTextAnchor = (angle) => {
            if (angle < -10) return "end";
            if (angle > 10) return "start";
            return "middle";
        };
        const getXOffset = (angle) => {
            if (angle < -10) return -10;
            if (angle > 10) return 10;
            return 0;
        };
        const getDotOffset = (angle, index) => {
            const isEdge = index === 0 || index === total - 1;
            const edgeOffset = isEdge ? Math.abs(angle) * 0.2 : 0;
            return 2 + edgeOffset;
        };
        const getLabelLines = (label) => {
            const safeLabel = (label || "").trim();
            const maxCharsPerLine = 18;

            if (!safeLabel) return [];
            if (safeLabel.length <= maxCharsPerLine) return [safeLabel];

            const words = safeLabel.split(/\s+/);
            if (words.length === 1) {
                return [
                    safeLabel.slice(0, maxCharsPerLine),
                    safeLabel.slice(maxCharsPerLine, maxCharsPerLine * 2).trim() + (safeLabel.length > maxCharsPerLine * 2 ? "..." : ""),
                ];
            }

            const lines = ["", ""];
            words.forEach((word) => {
                const nextFirstLine = lines[0] ? `${lines[0]} ${word}` : word;
                if (nextFirstLine.length <= maxCharsPerLine || !lines[0]) {
                    lines[0] = nextFirstLine;
                } else {
                    lines[1] = lines[1] ? `${lines[1]} ${word}` : word;
                }
            });

            if (lines[1].length > maxCharsPerLine * 1.5) {
                lines[1] = `${lines[1].slice(0, maxCharsPerLine).trim()}...`;
            }

            return lines.filter(Boolean);
        };

        return (
            <svg width={width} height={height}>
                <path
                    d={`M ${centerX - radius},${centerY} A ${radius},${radius} 0 0,1 ${centerX + radius},${centerY}`}
                    fill="none"
                    stroke="#94a3b8"
                    strokeWidth="1"
                />
                {data.map((item, index) => {
                    const { x, y, angle } = getCoordinates(index);
                    const color = item.color || getColor(typeof item.value === "number" ? item.value : 0);
                    const textAnchor = getTextAnchor(angle);
                    const xOffset = getXOffset(angle);
                    const valueOffset = getYOffset(angle);
                    const labelOffset = valueOffset + 20;
                    const labelLines = getLabelLines(item.label);
                    const adjustment = pointPositionAdjustments[index] || {};
                    const dotDx = adjustment.dotDx || 0;
                    const dotDy = adjustment.dotDy || 0;
                    const valueDx = adjustment.valueDx || 0;
                    const valueDy = adjustment.valueDy || 0;
                    const labelDx = adjustment.labelDx || 0;
                    const labelDy = adjustment.labelDy || 0;
                    const dotX = x + dotDx;
                    const dotY = y - getDotOffset(angle, index) + dotDy;
                    return (
                        <g key={index}>
                            <circle
                                cx={dotX}
                                cy={dotY}
                                r={dotRingRadius}
                                fill="none"
                                stroke={color}
                                strokeWidth={dotRingStrokeWidth}
                                opacity="0.22"
                            />
                            <circle
                                cx={dotX}
                                cy={dotY}
                                r={dotRadius}
                                fill={color}
                                style={{ filter: `drop-shadow(0 0 6px ${color})` }}
                            />
                            <text
                                x={x + xOffset + valueDx}
                                y={y + valueOffset + valueDy}
                                textAnchor={textAnchor}
                                fontSize="16"
                                fontWeight="600"
                                fill={color}
                            >
                                {typeof item.value === "number" ? item.value : 0}%
                            </text>
                            <text
                                x={x + xOffset + labelDx}
                                y={y + labelOffset + labelDy}
                                textAnchor={textAnchor}
                                fontSize="13"
                                fontWeight="500"
                                fill="#64748B"
                            >
                                {labelLines.map((line, lineIndex) => (
                                    <tspan
                                        key={`${index}-${lineIndex}`}
                                        x={x + xOffset + labelDx}
                                        dy={lineIndex === 0 ? 0 : 14}
                                    >
                                        {line}
                                    </tspan>
                                ))}
                            </text>
                        </g>
                    );
                })}
            </svg>
        );
    };

    // --------------- Radial gauge (ApexCharts) ---------------


    const getGradientByValue = (value) => {
        if (value < 41) {
            return [
                { offset: 0, color: "#FFADB1", opacity: 1 },
                { offset: 100, color: "#E7000B", opacity: 1 }
            ];
        }
        else if (value < 61) {

            return [
                { offset: 0, color: "#FFB834", opacity: 1 },
                { offset: 100, color: "#D08700", opacity: 1 }
            ];
        }
        else if (value < 91) {
            return [
                { offset: 0, color: "#FFF237", opacity: 1 },
                { offset: 100, color: "#D0C200", opacity: 1 }
            ];
        }
        else {
            return [
                { offset: 0, color: "#3CFFBE", opacity: 1 },
                { offset: 100, color: "#0C875E", opacity: 1 }
            ];
        }
    };

    const getColorByValue = (value) => {
        if (value < 41) return "#E7000B";
        if (value < 61) return "#D08700";
        if (value < 91) return "#BFB200";
        return "#0C875E";
    };

    // Use label from API response; fall back to computed value
    const healthLabel = healthLabelFromAPI ||
        (overallHealth >= 80 ? "Just Perfect!" :
            overallHealth >= 50 ? "Needs Attention" :
                "Critical!");

    const optionsinner = {
        chart: { type: "radialBar", offsetY: 8, sparkline: { enabled: true } },
        plotOptions: {
            radialBar: {
                startAngle: -100,
                endAngle: 100,
                hollow: { size: "75%" },
                track: { background: "rgba(255, 255, 255, 0.68)", strokeWidth: "100%" },
                dataLabels: {
                    name: {
                        show: true,
                        offsetY: 15,
                        fontSize: "16px",
                        color: "#0F172A",
                        fontWeight: 500,
                    },
                    value: {
                        offsetY: -35,
                        fontSize: "40px",
                        color: getColorByValue(overallHealth),
                        fontWeight: 500,
                        formatter: function () { return overallHealth + "%"; }
                    }
                }
            }
        },
        fill: {
            type: "gradient",
            gradient: {
                shade: "light",
                type: "horizontal",
                colorStops: getGradientByValue(overallHealth),
                stops: [0, 50, 100]
            }
        },
        states: {
            hover: {
                filter: { type: "none" }
            },
            active: {
                filter: { type: "none" }
            }
        },
        stroke: { lineCap: "round" },
        labels: [healthLabel]
    };

    const series = [overallHealth];

    // --------------- Accordion data (conditions object → array) ---------------
    const troubleshootingAccordionData = useMemo(() => {
        const conditionsObj = reportData?.conditions;
        if (!conditionsObj || typeof conditionsObj !== "object") return [];
        return Object.entries(conditionsObj).map(([key, val], idx) => {
            const { badgeClassName, badgeLabel } = getSeverityInfo(val?.severity);
            const health = typeof val?.healthScore === "number" ? val.healthScore : 0;
            const items = Array.isArray(val?.items) ? val.items : [];
            return {
                key: key || String(idx),
                title: camelToTitle(key),
                badgeClassName,
                badgeLabel,
                healthClassName: getHealthClass(health),
                healthValue: `${health.toFixed(1)}%`,
                tableData: items.map((c, i) => ({
                    key: `${key}-${i}`,
                    conditionName: c.conditionName || "-",
                    variableName: c.variableName || "-",
                    outputValue: c.outputValue != null && c.outputValue !== "" ? String(c.outputValue) : "-",
                    health: typeof c.healthPercent === "number" ? c.healthPercent : 0,
                })),
            };
        });
    }, [reportData]);

    const filteredAccordionData = useMemo(() => {
        const q = search.trim().toLowerCase();
        return troubleshootingAccordionData
            .map((item) => {
                let rows = item.tableData;
                if (showOnlyFailed) {
                    rows = rows.filter((c) => c.health !== 100);
                }
                if (q.length > 0) {
                    rows = rows.filter((c) =>
                        (c.conditionName || "").toLowerCase().includes(q) ||
                        (c.variableName || "").toLowerCase().includes(q) ||
                        String(c.outputValue ?? "").toLowerCase().includes(q)
                    );
                }
                return { ...item, tableData: rows };
            })
            .filter((item) => item.tableData.length > 0);
    }, [troubleshootingAccordionData, search, showOnlyFailed]);

    const defaultOpenAccordionItems = useMemo(
        () => troubleshootingAccordionData.map(({ key }) => key),
        [troubleshootingAccordionData]
    );

    // --------------- Table columns ---------------
    const trackingProfileConditionColumns = useMemo(() => ([
        {
            title: "Condition Name",
            dataIndex: "conditionName",
            key: "conditionName",
            width: "28%",

            render: (value) => {
                const normalizedType = normalizeInventoryType(rawInventoryType);
                const articleTitle = CONDITION_ARTICLE_MAP[`${value}|${normalizedType}`];
                if (articleTitle) {
                    const url = `/knowledgeBase?article=${encodeURIComponent(articleTitle)}`;
                    // <a
                    //     href={url}
                    //     target="_blank"
                    //     rel="noreferrer"
                    //     className="troubleshooting-health-table__condition troubleshooting-health-table__condition--link"
                    // >
                    //     {value || "-"}
                    // </a>
                    return (

                        <a
                            href={url}
                            target="_blank"
                            rel="noreferrer"
                        // className="troubleshooting-health-table__condition troubleshooting-health-table__condition--link"
                        >
                            < span className="troubleshooting-health-table__condition --interactive" >
                                <span className="troubleshooting-health-table__condition-text">{value || "-"}</span>
                                <span className="troubleshooting-health-table__condition-arrow" aria-hidden="true">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M4.7002 11.3003L11.2999 4.70063" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M4.7002 4.7002H11.2999V11.2999" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </span>
                            </span>
                        </a>

                    );
                }
                return <span className="troubleshooting-health-table__condition">{value || "-"}</span>;
            }
        },
        {
            title: "Variable Name",
            dataIndex: "variableName",
            key: "variableName",
            width: "30%",
            // render: (value) => (
            //     <span className="troubleshooting-health-table__variable">{value || "-"}</span>
            // )
            render: (value) => {
                const str = value != null && value !== "" ? String(value) : "-";
                const shouldShowTooltip = str.length > 52;
                if (!shouldShowTooltip) {
                    return <span className="troubleshooting-health-table__output">{str}</span>;
                }
                return (
                    <Tooltip title={str} placement="top" overlayClassName="troubleshooting-health-tooltip">
                        <span className="troubleshooting-health-table__output">{str.slice(0, 52)}...</span>
                    </Tooltip>
                );
            }
        },
        {
            title: "Output Value",
            dataIndex: "outputValue",
            key: "outputValue",
            width: "46%",
            render: (value) => {
                const str = value != null && value !== "" ? String(value) : "-";
                const shouldShowTooltip = str.length > 85;
                if (!shouldShowTooltip) {
                    return <span className="troubleshooting-health-table__output">{str}</span>;
                }
                return (
                    <Tooltip title={str} placement="top" overlayClassName="troubleshooting-health-tooltip">
                        <span className="troubleshooting-health-table__output">{str.slice(0, 85)}...</span>
                    </Tooltip>
                );
            }
        },
        {
            title: "Health %",
            dataIndex: "health",
            key: "health",
            align: "right",
            width: "8%",
            render: (value) => {
                const h = typeof value === "number" ? value : 0;
                const healthClassName =
                    h >= 91 ? "--green" :
                        h >= 61 ? "--yellow" :
                            h >= 41 ? "--orange" :
                                "--red";
                return (
                    <span className={`troubleshooting-health-table__health ${healthClassName}`}>
                        {h.toFixed(1)}%
                    </span>
                );
            }
        }
    ]), [rawInventoryType]);

    return (
        <div className="container_box--wrapper pt_header">
            <div className="container_box--breadcrumb">
                <ul className="container_box--breadcrumb-list">
                    <li>
                        <Link onClick={() => handlePageViewChange("table", "no")}>
                            <img src={HealthCenterIcon} alt="USP" /> Health Center
                        </Link>
                    </li>
                    <li className="primary">{taskId}</li>
                </ul>
            </div>

            <div className="container_box--wrapper--title d-flex align-items-center justify-content-between">
                <div className="back_btn_d2">
                    <img
                        src={backButton}
                        className="img-fluid"
                        alt=""
                        onClick={() => handlePageViewChange("table", "no")}
                    />
                    <h1 className="heading">
                        {taskName !== "-" ? (
                            <>
                                {taskName}
                                {platform !== "-" && (
                                    <> - <span className='light_weight_text'>{platform}</span></>
                                )}
                            </>
                        ) : "-"}
                    </h1>
                </div>
                <div className='searchbar_with_btns p-0' style={{ display: 'flex', gap: '1rem' }}>
                    <div className='export_btn_hover_d2'>
                        <Button
                            className="export_btn_d2"
                            onClick={handlePdfExport}
                            disabled={pdfExporting || filteredAccordionData.length === 0}
                            style={{ opacity: (pdfExporting || filteredAccordionData.length === 0) ? "0.5" : "1" }}
                            icon={
                                pdfExporting
                                    ? <img src={FullLoader} width={14} height={14} alt="loading" />
                                    : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <g clipPath="url(#clip0_11006_24214)">
                                            <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M7 8.75V1.75" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_11006_24214">
                                                <rect width="14" height="14" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                            }
                        >
                            Export
                        </Button>
                    </div>
                    {/* <div className='export_btn_hover_d2'>
                        <Button
                            className="export_btn_d2"
                            onClick={handleDownload}
                            disabled={downloading}
                            icon={
                                downloading
                                    ? <img src={FullLoader} width={14} height={14} alt="loading" />
                                    : <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <g clipPath="url(#clip0_11006_24214)">
                                            <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M7 8.75V1.75" stroke="#1E293B" strokeWidth="1.54" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_11006_24214">
                                                <rect width="14" height="14" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                            }
                        >
                            Export
                        </Button>
                    </div> */}
                </div>
            </div>



            {apiMessage ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
                    <p style={{ color: '#64748B', fontSize: '16px', textAlign: 'center' }}>{apiMessage}</p>
                </div>
            ) : (
                <div className="container_box--content pt_20" ref={pdfRef}>
                    {loading ?
                        <div
                            className="d-flex justify-content-center align-items-center"

                        >
                            {/* <img
                            src={FullLoader}
                            width={50}
                            height={50}
                            alt="" /> */}
                        </div>
                        :
                        <div className="container_box--collaspe_form">
                            <Row>
                                {/* ---- Health Chart Section ---- */}
                                <Col span={24}>
                                    <div className='health_bar_div'>
                                        <Row>
                                            <Col span={13} className='position-relative'>
                                                <div className='bar_heading'>
                                                    <h3>Overall System Health</h3>
                                                </div>
                                                <div className='outer_inner_round_svg'>
                                                    <img src={OuterRoundSVG} className='img-fluid outer_round_img' alt="" />
                                                    <img src={InnerRoundSVG} className='img-fluid inner_round_img' alt="" />
                                                </div>
                                                <div className='round_chart_div'>
                                                    <RadialChart data={profiles} />
                                                </div>
                                                <div className={
                                                    overallHealth < 41 ? 'blur_imgs --red_img' :
                                                        overallHealth < 61 ? 'blur_imgs --orange_img' :
                                                            overallHealth < 91 ? 'blur_imgs --yellow_img' :
                                                                'blur_imgs --green_img'
                                                }>
                                                    <img src={GreenBlurImg} className='img-fluid green' alt="" />
                                                    <img src={YellowBlurImg} className='img-fluid yellow' alt="" />
                                                    <img src={OrangeBlurImg} className='img-fluid orange' alt="" />
                                                    <img src={RedBlurImg} className='img-fluid red' alt="" />
                                                </div>
                                                <div className='inner_chart_div'>
                                                    <Chart options={optionsinner} series={series} type="radialBar" height={250} />
                                                </div>
                                            </Col>

                                            {/* ---- Stats Section ---- */}
                                            <Col span={11}>
                                                <div className='health_bar_details_div'>
                                                    <Row style={{ gap: '5rem 0rem' }}>
                                                        <Col span={12}>
                                                            <div className='img_width_text'>
                                                                <img src={SampleAnalyzedIcon} className='img-fluid' alt="" />
                                                                <div>
                                                                    <span>Sample Analyzed</span>
                                                                    <h4>{sampleAnalyzed}</h4>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className='img_width_text'>
                                                                <img src={FailedIcon} className='img-fluid' alt="" />
                                                                <div>
                                                                    <span>Failed</span>
                                                                    <h4 className='--red'>{failed}</h4>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className='img_width_text'>
                                                                <img src={PlatformIcon} className='img-fluid' alt="" />
                                                                <div>
                                                                    <span>Platform</span>
                                                                    <h4 style={{ textTransform: "capitalize" }}>{platform}</h4>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className='img_width_text'>
                                                                <img src={PublisherIcon} className='img-fluid' alt="" />
                                                                <div>
                                                                    <span>Publisher</span>
                                                                    <h4>{publisherId}</h4>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className='img_width_text'>
                                                                <img src={InventoryIcon} className='img-fluid' alt="" />
                                                                <div>
                                                                    <span>Inventory Type</span>
                                                                    <h4>{inventoryTypeDisplay}</h4>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className='img_width_text'>
                                                                <img src={ZoneIcon} className='img-fluid' alt="" />
                                                                <div>
                                                                    <span>No. of Zone(s)</span>
                                                                    {/*  */}
                                                                    <Tooltip
                                                                        placement="top"
                                                                        title={allZones.length > 0
                                                                            ?
                                                                            <div style={{ width: '40rem', maxHeight: '40rem', overflowY: 'auto' }}>
                                                                                <div>{allZones.map((z, i) => <div key={i}>{z}</div>)}</div>
                                                                            </div>
                                                                            : "-"
                                                                        }
                                                                        overlayStyle={{ maxWidth: '62rem' }}
                                                                    >
                                                                        <small className='--green'>{zoneCount}</small>
                                                                    </Tooltip>
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>

                                {/* ---- Search + Toggle ---- */}
                                <Col span={24}>
                                    <div className='search_with_toggle_design'>
                                        <div className="form_content_block--group">
                                            <Input
                                                style={{ width: '32rem' }}
                                                type='text'
                                                className='form_control basic md search_input w_table_search'
                                                placeholder="Search"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                        </div>
                                        <div className='toggle_with_text_design'>
                                            <div className="container_box--form-container toggle_with_text_design">
                                                <div className="form_content_block--group mb_0 d_flex align_items_center justify_content_between">
                                                    <label className='form_label form_label_switch'>Show only Failed Conditions</label>
                                                    <Switch
                                                        checked={showOnlyFailed}
                                                        onChange={(checked) => setShowOnlyFailed(checked)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* ---- Accordion ---- */}
                                <Col span={24}>
                                    <div className="custom_collapse_design">
                                        {filteredAccordionData.length > 0 ? (
                                            <Accordion alwaysOpen defaultActiveKey={defaultOpenAccordionItems}>
                                                {filteredAccordionData.map((accordionItem) => (
                                                    <Accordion.Item eventKey={accordionItem.key} key={accordionItem.key}>
                                                        <Accordion.Header>
                                                            <div className='d-flex align-items-end justify-content-between w-100'>
                                                                <div className='text_with_badge'>
                                                                    {accordionItem.title}
                                                                    <span className={accordionItem.badgeClassName}>
                                                                        {accordionItem.badgeLabel}
                                                                    </span>
                                                                </div>
                                                                <h4 className={accordionItem.healthClassName}>
                                                                    {accordionItem.healthValue}
                                                                </h4>
                                                            </div>
                                                        </Accordion.Header>
                                                        <Accordion.Body className='--different_page_accordion'>
                                                            <div className='troubleshooting-health-table'>
                                                                <Table
                                                                    columns={trackingProfileConditionColumns}
                                                                    dataSource={accordionItem.tableData}
                                                                    pagination={false}
                                                                    rowKey="key"
                                                                    tableLayout="fixed"
                                                                    showSorterTooltip={false}
                                                                />
                                                            </div>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                ))}
                                            </Accordion>
                                        ) : (
                                            <div style={{ textAlign: 'center', padding: '3rem', color: '#64748B' }}>
                                                No conditions found.
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    }
                </div>
            )}

        </div>
    );
};

export default ViewReportV2;
